module.exports = __webpack_public_path__ + "media/images/member_point-91453429c5941ba330698914716683d8.svg";